export default __webpack_public_path__ + "static/media/emp.c33d0058.png";